import React, { useState, memo, useRef, useEffect } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { MdDone, MdClear, MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";
import { TextInput } from "../../Shared/Forms";
import { Row, Col, UncontrolledAlert, Card, CardHeader, CardBody, Button } from "reactstrap";

import { adminMealPlanServices } from "./service/adminMealPlan.service";
import TextEditor from "../../Shared/Forms/TextEditor";
import { Spinner } from "../../Shared";
import ConfirmationModal from "../../Shared/ConfirmationModal";
import { toast } from "react-toastify";
import { AdminViewPendingMealPlans } from "../../../_constants/RouteVariables";

const AdminViewSpecificMealPLan = memo((props) => {
    const adminmealPlanFormRef = useRef("adminMealPlanForm");
    const submitMealPlanRef = useRef("approveMealPlan");

    const [name, setName] = useState(null);
    const [description, setDescription] = useState(null);
    const [calories, setCalories] = useState(null);
    const [generalImageUrl, setGeneralImageUrl] = useState(null);
    const [days, setDays] = useState(null);
    const [mealId, setMealId] = useState(null);
    const [roaster, setRoaster] = useState(null);
    const [status, setStatus] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [canSubmit, setCanSubmit] = useState(false);
    //Approved or decline a meal plan
    const [responseError, setResponseError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isDeclineClick, setIsDeclineClick] = useState(false);
    const [declineCommit, setDeclineCommit] = useState(null);
    const [reviewerRemarks, setReviewerRemarks] = useState(null);
    //image error handling..
    const [error, setError] = useState(null);
    const dailyMealRoaster = async (id) => {
        try {
            let response = await adminMealPlanServices.getDailyMealRoaster(id);
            if (response) {
                setRoaster(response.data);
                setIsEdit(true);
            }
        } catch (e) {
            setError(e);
        }
    };

    const routeChange = () => {
        let path = `/admin-pending-meal-plans`;
        props.history.push(path);
    };
    const resetDeclineForm = () => {
        setDeclineCommit(null);
    };
    const redraftMealPost = async (data, id) => {
        try {
            setSubmitting(true);
            setCanSubmit(true);
            let response = await adminMealPlanServices.declinedMealPlan(data, id);
            if (response == null) {
                setSubmitting(false);
                setCanSubmit(false);
                setIsDeclineClick(false);
                toast.success("Meal plan sent for redraft successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
                resetDeclineForm();
                routeChange();
            }
        } catch (e) {
            setResponseError(e);
            setSubmitting(false);
            setCanSubmit(false);
        }
    };
    const approveMealPost = async (id) => {
        try {
            let approvedData = {
                status: "APPROVED",
                remarks: "",
            };
            setSubmitting(true);
            setCanSubmit(true);
            let response = await adminMealPlanServices.declinedMealPlan(approvedData, id);
            if (response == null) {
                setSubmitting(false);
                setCanSubmit(false);
                setIsDeclineClick(false);
                toast.success("Meal plan approved successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
                resetDeclineForm();
                routeChange();
            }
        } catch (e) {
            setResponseError(e);
            setSubmitting(false);
            setCanSubmit(false);
        }
    };
    const showConfirmation = () => {
        setShowModal(!showModal);
        setIsDeclineClick(false);
    };

    const stopEdit = () => {
        setIsEdit(false);
    };
    const createRequest = (data) => {
        let requestBody = { status: "DECLINED", ...data };
        return requestBody;
    };

    const declineConfirmation = (data) => {
        setShowModal(!showModal);
        setIsDeclineClick(true);
        setDeclineCommit(data);
    };

    const enableButton = () => {
        setCanSubmit(true);
    };
    const disableButton = () => {
        setCanSubmit(false);
    };
    const approvedPost = (id) => {
        //check for decline and approved api

        if (isDeclineClick) {
            // integrate with the decline api...

            redraftMealPost(declineCommit, id);
        } else {
            approveMealPost(id);
        }
    };
    const mapMealType = (mealType) => {
        switch (mealType) {
            case 1:
                return "Others";
            case 2:
                return "BreakFast";
            case 3:
                return "Lunch";
            case 4:
                return "Dinner";
            case 5:
                return "Snack";
        }
    };

    const handleSubmit = (data) => {
        let requestData = createRequest(data);
        setIsDeclineClick(true);

        /// show the decline modal...
        declineConfirmation(requestData);
    };

    useEffect(() => {
        if (props && props.location) {
            const { mealData } = props.location.state;

            setStatus(mealData.status);
            setReviewerRemarks(mealData.reviewerRemarks);
            setMealId(mealData.id);
            setName(mealData.name);
            setDescription(mealData.description);
            setCalories(mealData.calories);
            setGeneralImageUrl(mealData.imageUrl);
            setDays(mealData.durationDays);
        }
    }, []);

    useEffect(() => {
        if (mealId) {
            dailyMealRoaster(mealId);
        }
    }, [mealId]);

    return (
        <React.Fragment>
            <NavLink to={AdminViewPendingMealPlans}>
                <Button type="button" color="primary" className="mb-2">
                    <MdArrowBack />
                    <span>Back</span>
                </Button>
            </NavLink>
            <Formsy ref={adminmealPlanFormRef}>
                {error && !error.errors ? <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert> : null}
                {error && error.errors && error.error.length ? (
                    <UncontrolledAlert color="danger">
                        {error.errors.map((error, index) => (
                            <p key={index}>{error.message}</p>
                        ))}
                    </UncontrolledAlert>
                ) : null}
                <Card>
                    <CardHeader>View Meal Plan</CardHeader>
                    <CardBody>
                        <Row>
                            <Col sm="5">
                                <TextInput name="name" required title="Name" disabled={true} value={name ? name : null} />
                                <TextInput name="description" required title="Description" disabled={true} value={description ? description : null} />
                                <TextInput name="calories" required title="Calories (Kcals)" disabled={true} value={calories ? calories : null} />
                            </Col>
                            <Col sm="7">
                                <div style={{ width: "74%" }}>
                                    <TextInput name="durationDays" required title="Duration (Day(s))" disabled={true} value={days ? days : null} />
                                </div>

                                <div style={{ paddingTop: "1rem" }} className="frame">
                                    <img src={`${generalImageUrl}`} alt="" height="100%" width="100%"></img>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12" md={{ size: 6, offset: 1 }}>
                                <Card>
                                    <CardHeader className="mb-2">Meal Roster</CardHeader>
                                    {roaster &&
                                        roaster.map((e, index) => (
                                            <CardBody className="mealRoasterFrame mb-2" id={index}>
                                                <span>DAY {e.day}</span>

                                                {e &&
                                                    e.plan.map((i, index) => (
                                                        <Card id={index}>
                                                            <CardHeader>Meal type : {mapMealType(i.mealType)}</CardHeader>
                                                            <CardBody>
                                                                <p>Food item(s):</p>
                                                                {i &&
                                                                    i.meal.map((k, v) => (
                                                                        <Card className="mb-2" id={v}>
                                                                            <CardBody>
                                                                                <Row className="measurementSpaces mb-2">
                                                                                    <Col>
                                                                                        {" "}
                                                                                        <small>{"Food Item"}</small>
                                                                                    </Col>
                                                                                    <Col>
                                                                                        <small>{"Metric Unit"}</small>
                                                                                    </Col>
                                                                                    <Col>
                                                                                        <small>{"Quantity"}</small>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row className="measurementSpaces">
                                                                                    <Col>
                                                                                        <small>{k && k.name}</small>
                                                                                    </Col>
                                                                                    <Col>
                                                                                        <small>{k && k.measure}</small>
                                                                                    </Col>
                                                                                    <Col>
                                                                                        <small>{k && k.quantity}</small>
                                                                                    </Col>
                                                                                </Row>
                                                                            </CardBody>
                                                                        </Card>
                                                                    ))}
                                                                <Formsy>
                                                                    <TextInput name="recipes" title="Recipes Title" disabled={true} value={i && i.recipe ? i.recipe.title : null} />
                                                                    <TextEditor name="body" value={null} isViewOnly={true} isEdit={isEdit} stopEdit={stopEdit} postBody={i.recipe.content} toolbarHidden={true} stripPastedStyles={true} mealType={true} recipe={`Recipes`} />
                                                                </Formsy>
                                                            </CardBody>
                                                        </Card>
                                                    ))}
                                            </CardBody>
                                        ))}
                                </Card>
                            </Col>
                            {status === "PENDING" ? (
                                <aside>
                                    <Card style={{ minWidth: "20rem" }}>
                                        <CardHeader>Publish</CardHeader>
                                        <CardBody>
                                            {" "}
                                            {responseError ? <UncontrolledAlert color="danger">{responseError.message}</UncontrolledAlert> : null}
                                            <Formsy ref={submitMealPlanRef} onValidSubmit={handleSubmit} onValid={enableButton} onInvalid={disableButton} noValidate>
                                                <TextInput
                                                    name="remarks"
                                                    type="textarea"
                                                    value={null}
                                                    required
                                                    disabled={submitting}
                                                    title="Comment"
                                                    validations={{
                                                        minLength: 5,
                                                        maxLength: 250,
                                                    }}
                                                    validationErrors={{
                                                        minLength: "Minimum of 5 characters allowed",
                                                        maxLength: "Maximum of 250 characters allowed",
                                                    }}
                                                />
                                                <Row>
                                                    <Col sm="6">
                                                        <Button type="button" size="lg" block color="success" className="mb-2" onClick={showConfirmation} disabled={canSubmit}>
                                                            {submitting ? (
                                                                <Spinner size="sm" />
                                                            ) : (
                                                                <span>
                                                                    <MdDone /> Approve
                                                                </span>
                                                            )}
                                                        </Button>
                                                    </Col>
                                                    <Col sm="6">
                                                        <Button size="lg" type="submit" className="mb-2" color="danger" block disabled={!canSubmit || submitting}>
                                                            {submitting ? (
                                                                <Spinner size="sm" />
                                                            ) : (
                                                                <span>
                                                                    <MdClear />
                                                                    Redraft
                                                                </span>
                                                            )}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Formsy>
                                        </CardBody>
                                    </Card>
                                </aside>
                            ) : null}

                            {status === "DECLINED" ? (
                                <aside>
                                    <Card style={{ minWidth: "20rem" }}>
                                        <CardHeader>Comment</CardHeader>
                                        <CardBody>
                                            <p>{reviewerRemarks}</p>
                                        </CardBody>
                                    </Card>
                                </aside>
                            ) : null}
                        </Row>
                    </CardBody>
                </Card>
            </Formsy>
            <ConfirmationModal isOpen={showModal} showModal={showConfirmation} action={() => approvedPost(mealId)} message={isDeclineClick ? "Do you want to decline the meal plan?" : "Do you want to approve this meal plan?"} />
        </React.Fragment>
    );
});

export default withRouter(AdminViewSpecificMealPLan);
